import { render, staticRenderFns } from "./GratingWallpaper.vue?vue&type=template&id=5a7e57dc&scoped=true"
import script from "./GratingWallpaper.vue?vue&type=script&lang=js"
export * from "./GratingWallpaper.vue?vue&type=script&lang=js"
import style0 from "./GratingWallpaper.vue?vue&type=style&index=0&id=5a7e57dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e57dc",
  null
  
)

export default component.exports